import React, {useEffect, useState} from "react";
import general from "../../general";
import {Link} from "react-router-dom";
import $ from "jquery";
import {useScroll, useLockFn, useMount} from "ahooks";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";
import useActiveState from '../../lib/useActiveState';
import {CopyToClipboard} from "react-copy-to-clipboard/lib/Component";
import {NavLink} from "../../lib/Navigation";
import Subtitle from "../components/Subtitle";
import { CloseOutlined } from "@ant-design/icons";
import FreeEdition from "../components/FreeEdition";

// export default ({active, type}) => {
export default props => {
  
  const [page, setPage] = useState(1);
  const [games, setGames] = useState([]);
  const [more, setMore] = useState(true);
  const [obsolete, setObsolete] = useState();
  const [user] = useActiveState('user');
  const [agent] = useActiveState('agent');
  const [randomColorInfo] = useActiveState('randomColorInfo');//随机颜色数组
  const [init, setInit] = useState(false);//状态
  const [exchangeState, setExchangeState] = useState(false);//兑换弹框的状态
  const [info, setInfo] = useState([]);
  const [items, setItems] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [contents, setContents] = useState([]);

  const load = useLockFn(async (parms = {}) => {
    Dialog.loading();
    let tmp = {
      // pagination: {count: 20, page: page},
    };

    tmp.id = props.query.id;
    // if (parms.page) {
    //   tmp.pagination.page = parms.page;
    // }
    await general.axios.post('/transferV2/info', tmp)
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let {status, data} = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }

        setInit(true);
        setObsolete(false);
        setInfo(data.info);
        setItems(data.items);
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  });

  useEffect(() => {
    if (props.active && !init) {
      load();
    }
  }, [props.active]);

  const exchange = item => {
    if(Number(info?.score?.toFixed(1)) < Number(item.score)) {
      Dialog.info('转游点不足，无法兑换');
      return;
    }
    setContents(item);
    setExchangeState(true);
  }

  const comfirm = () => {
    if(Number(info?.score?.toFixed(1)) < Number(contents.score)) {
      Dialog.info('转游点不足，无法兑换');
      return;
    }
    Dialog.loading();

    let tmp = {};
    if(props.query.id) {
      tmp.trans_id = props.query.id;
    } else {
      tmp.trans_id = info.trans_id;
    }
    tmp.id = contents.id;
    tmp.type = contents.type;
    
    setExchangeState(false);
    general.axios.post('/transferV2/receive', tmp)
    .finally(() => {
      Dialog.close();
    })
    .then(response => {
      let {status, data} = response.data;
      if (!status.succeed) {
        Dialog.error(status.error_desc);
        return;
      }

      Dialog.info("兑换成功");
      load();
    })
    .catch(err => {
      Dialog.error(err.message);
    });
  }

  return <>{init ? <div className="around-detail">
    {info ?
    <Link to={'/game?mid=' + info?.maiyouGameid} className="game-info" >
      <div className="icon">
        <Image src={info?.logo?.thumb}/>
      </div>
      <div className="subject">
        <div className="text">
          <div className="name">
            <div className={" " + (info?.nameRemark ? " name-new" : "")}>
              {info?.topLable != '' ? <span className="span">{info.topLable}</span> : null}
              {info?.gameName}
            </div>
          </div>
          <div className="info1">
            {info?.versioncode}
            <Subtitle>{info?.nameRemark}</Subtitle>
          </div>
          {info?.bottomLable && Object.keys(info.bottomLable).length > 0 ?
            <div className="info3">
              <span className="first-text" style={{background: info.bottomLable.type == 1 ? '#FF8C50' : '#9F9DFC'}}>{info.bottomLable.left_content}</span>
              <span className="second-text" style={{color: info.bottomLable.type == 1 ? '#FF8C50' : '#9F9DFC', borderColor: info.bottomLable.type == 1 ? '#FF8C50' : '#9F9DFC'}}>{info.bottomLable.right_content}</span>
            </div>
          : null}
        </div>
      </div>
      <FreeEdition centerStyle={true}>{info}</FreeEdition>
    </Link>
    : null}

    {/* Tab 栏 */}
    <div className="around-tab-bar">
      <div className="around-tabs">
        {items.map((group, index) => (
          <div
            key={index}
            className={'around-tab-item' + (items.length > 1 ? (activeTab === index ? ' active' : ' disable') : ' default')}
            onClick={() => setActiveTab(index)}
          >
            {group.title}
          </div>
        ))}
      </div>
      <div className="around-tab-score">
        我的转游点：<span>{info?.score == 0 ? 0 : info?.score?.toFixed(1)}</span>
      </div>
    </div>

    <div className="items">
      {items[activeTab]?.items?.map((item, index) => (
        <div className="item" key={item.id || index} onClick={() => {
          if (item.isReceived) {
            return
          }
          setContents(item);
          setExchangeState(true)
        }}>
          <div className="text">
            <div className="name">{item.name}</div>
            <div className="info">{item.remark}</div>
          </div>
          <div className="base">
            {item.isReceived ?
              <CopyToClipboard text={item.packCard} onCopy={() => Dialog.info('复制成功')}>
                <div className="operate copy">复制</div>
              </CopyToClipboard>
              :
              <div className="operate" onClick={(e) => {
                e.stopPropagation();
                exchange(item);
              }}>兑换</div>
            }
            <div className="info">{item.score}转游点</div>
          </div>
        </div>
      ))}
    </div>

    {exchangeState ? 
    <div className="exchange-index">
      <div className="exchange-site">
        <div className="exchange-main">
          <div className="close"  onClick={() => setExchangeState(false)}>
            <CloseOutlined style={{fontSize:16,color:'#666'}}></CloseOutlined>
          </div>
          <div className="exchange-title">
            {/* 200元代金券 */}
            {contents?.name}
          </div>
          <div className="info">
            <p>{contents?.type == 1 ? '使用要求' : '礼包内容'} ：{contents?.remark}</p>
            <p>消耗转游点数：{contents?.score}转游点</p>
            {info?.countAlt > 0 ? <p className="des2">提示：您有{info.countAlt}个小号可回收，回收可获得{info?.altBalance}金币。</p> : null}
          </div>
          <div className="exchange-btn">
            <div className="item btn-confirm" onClick={() => comfirm()}>
              兑换
            </div>
            {info?.countAlt > 0 ? 
            <NavLink to="/recovery" className="item btn-about" >
              回收小号
            </NavLink>
            : null}
          </div>
        </div>
      </div>
    </div>
    : null}

  </div> : null}</>
};